export default __webpack_public_path__ + "7b99104d4faf1a975f9358f8ad259c6c.svg";